import { z } from 'zod';

export const integrationTypeSchema = z.enum(['GHL', 'GA4', 'RESEND']);
export type IntegrationType = z.infer<typeof integrationTypeSchema>;

export const integrationStatusSchema = z.enum([
  'CONNECTED',
  'DISCONNECTED',
  'ERROR',
  'PENDING_OAUTH',
]);
export type IntegrationStatus = z.infer<typeof integrationStatusSchema>;

export const ghlConfigSchema = z.object({
  apiKey: z.string().min(10, 'GHL API key must be at least 10 characters'),
});
export type GhlConfig = z.infer<typeof ghlConfigSchema>;

export const ga4ConfigSchema = z.object({
  propertyId: z.string().regex(/^\d+$/, 'GA4 property ID must be numeric').min(6),
});
export type Ga4Config = z.infer<typeof ga4ConfigSchema>;

export const resendConfigSchema = z.object({
  apiKey: z.string().startsWith('re_', 'Resend API key must start with "re_"').min(10),
  inboundDomain: z
    .string()
    .regex(
      /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)+$/i,
      'Must be a valid FQDN',
    ),
});
export type ResendConfig = z.infer<typeof resendConfigSchema>;

export const integrationConfigSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('GHL'), config: ghlConfigSchema }),
  z.object({ type: z.literal('GA4'), config: ga4ConfigSchema }),
  z.object({ type: z.literal('RESEND'), config: resendConfigSchema }),
]);

export const integrationSummarySchema = z.object({
  type: integrationTypeSchema,
  status: integrationStatusSchema,
  lastCheckedAt: z.string().datetime().nullable(),
  lastError: z.string().nullable(),
  metadata: z.record(z.unknown()).nullable(),
});
export type IntegrationSummary = z.infer<typeof integrationSummarySchema>;

export const integrationListResponseSchema = z.object({
  integrations: z.array(integrationSummarySchema),
});

export const integrationTestResponseSchema = z.object({
  ok: z.boolean(),
  status: integrationStatusSchema,
  lastCheckedAt: z.string().datetime(),
  error: z.string().nullable(),
});
